import { Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { TopicsComponent } from './components/topics/topics.component';
import { CollectionsComponent } from './components/collections/collections.component';
import { CollectionComponent } from './components/collection/collection.component';
import { SearchComponent } from './components/search/search.component';
import { authGuard } from './core/auth.guard';


export const routes: Routes = [
    {path: 'login', component: LoginComponent},
    {path: 'topics', component: TopicsComponent, canActivate: [authGuard]},
    {path: 'topics/:collection', component: TopicsComponent, canActivate: [authGuard]},
    {path: 'collections', component: CollectionsComponent, canActivate: [authGuard]},
    {path: 'collection/:name', component: CollectionComponent, canActivate: [authGuard]},
    {path: 'search/:collection', component: SearchComponent, canActivate: [authGuard]},
    {path: '', redirectTo: '/collections', pathMatch: 'full'},
    {path: '**', redirectTo: '/collections'}
];

